<template>
	<div class="niangzao">
		<div class="nz_wrap">
			<div class="nz_box1" data-aos="fade-up">
				<p class="nz_tit">传统酿造工艺</p>
				<ul class="nzgy_list flex1">
					<li class="nzgy_item">
						<div class="ztm_d1">
							<img src="@/images/gongyi/gy_img1.png" />
							<p>“天益老号”老窖池</p>
						</div>
						<div class="ztm_d2">
							<p>窖龄越长，其香越幽，其味越正，其品越高，</p>
							<p>绵延了千百年的老窖池——天益老号生生不息，</p>
							<p>其别具一格自成体系的微观生态环境，</p>
							<p>对剑南春基础酒的品质起着关键的作用。</p>
						</div>
					</li>
					<li class="nzgy_item">
						<div class="ztm_d1">
							<img src="@/images/gongyi/gy_img3.png" />
							<p>精选纯粮酿造</p>
						</div>
						<div class="ztm_d2">
							<p>剑南春甄选优质</p>
							<p>
								高粱、小麦、大米、糯米、玉米等粮食为原料，
							</p>
							<p>传承绵竹千年酿酒技艺的精华，科学配比，</p>
							<p>发挥纯粮独特酿造优势，成就经典浓香滋味。</p>
						</div>
					</li>
				</ul>
			</div>
			<div class="nz_box2">
				<div data-aos="fade-up" class="nb2_img">
					<img src="@/images/gongyi/gy_img44.png" />
				</div>
				<div class="nb2_text flex2 wow animate__animated animate__fadeInRight">
					<div class="nb2_text_con">
						<p class="tcon_p1">独特的制曲模式</p>
						<p class="tcon_p2">
							剑南春使用的是依靠天然微生物接种制作的大曲药，在用曲之道上，剑南春融汇众长，反复锤炼，其酿制之酒，得曲之神韵，既保证了产量，又保证了酿制过程中各种复杂香味物质的生化合成。
						</p>
					</div>
				</div>
			</div>
			<div data-aos="fade-up" class="nz_box1">
				<ul class="nzgy_list flex1">
					<li class="nzgy_item">
						<div class="ztm_d1">
							<img src="@/images/gongyi/gy_img10.png" />
							<p>独创的经典工艺</p>
						</div>
						<div class="ztm_d2">
							<p>
								剑南春的传统酿造工艺入选了国家非物质文化遗产，
							</p>
							<p>在传承古老酿艺的同时，</p>
							<p>
								剑南春独创了中国传统浓香型白酒生产的经典特色工艺——
							</p>
							<p class="font600">
								“一低、二长、三控、四适当、五精作、六结合”。
							</p>
						</div>
					</li>
					<li class="nzgy_item">
						<div class="ztm_d1">
							<img src="@/images/gongyi/gy_img11.png" />
							<p>陶坛贮存老熟</p>
						</div>
						<div class="ztm_d2">
							<p>贮藏是白酒传统工艺中一道重要的工序，</p>
							<p>剑南春酒采用陶坛贮存老熟，</p>
							<p>经年储存的白酒在陶坛中成熟蜕变，</p>
							<p>
								滋味随贮存时间的增加更加突出，滋味更加悠美、绵柔。
							</p>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="rd_box">
			<record></record>
		</div>
	</div>
</template>

<script>
export default {
	mounted() {

	},
};
</script>

<style lang="scss">
.niangzao {
	@font-face {
		font-family: "SourceHanSans";
		src: url("../../font/SourceHanSansCN-Regular.otf");
	}
	font-family: "SourceHanSans";
	box-sizing: border-box;
	margin-top: 76px;
	width: 100%;
	background-image: url("../../images/bgimg3.png");
	padding: 72px 20px 80px 20px;
	.nz_wrap {
		max-width: 1500px;
		min-width: 950px;
		margin: 0 auto;
		.nz_box1 {
			.nz_tit {
				text-align: center;
				font-size: 36px;
				color: #c0494b;
				margin-bottom: 76px;
			}
			.nzgy_list {
				align-items: flex-start;
				margin: 0 -30px;
				.nzgy_item {
					margin-bottom: 85px;
					width: 50%;
					padding: 0 30px;
					.ztm_d1 {
						position: relative;
						overflow: hidden;
						img {
							transition: transform 0.5s ease;
							width: 100%;
							&:hover {
								transform: scale(1.1);
							}
						}
						p {
							position: absolute;
							bottom: 28px;
							width: 100%;
							left: 0;
							background-image: url("../../images/gongyi/gy_img2.png");
							background-repeat: no-repeat;
							background-position: 50%;
							height: 65px;
							line-height: 65px;
							text-align: center;
							z-index: 9;
							font-size: 30px;
							color: #fff;
						}
					}
					.ztm_d2 {
						color: #333;
						font-size: 18px;
						text-align: center;
						line-height: 1.8;
						padding-top: 38px;
					}
				}
			}
		}
		.nz_box2 {
			position: relative;
			margin-bottom: 100px;
			.nb2_img {
				overflow: hidden;
				animation-duration: 1.5s;
				img {
					width: 100%;
					display: block;
					transition: transform 0.5s ease;
					&:hover {
						transform: scale(1.05);
					}
				}
			}
			.nb2_text {
				position: absolute;
				right: 0;
				top: 0;
				bottom: 0;
				width: 472px;
				background-color: rgba(87, 57, 36, 0.4);
				padding: 20px 70px;
				box-sizing: border-box;
				animation-duration: 1.5s;
				.nb2_text_con {
					max-width: 310px;
					.tcon_p1 {
						color: #fff;
						font-size: 30px;
						margin-bottom: 30px;
						text-align: center;
						background-image: url("../../images/gongyi/gy_img6.png");
						background-repeat: no-repeat;
						background-position: 50%;
						height: 65px;
						line-height: 65px;
					}
					.tcon_p2 {
						color: #fff;
						font-size: 18px;
						line-height: 1.8;
					}
				}
			}
		}
	}
	@media screen and (max-width: 1650px) {
        .nz_wrap {
            max-width: 1400px;
        }
	}
    @media screen and (max-width: 1550px) {
        .nz_wrap {
            max-width: 1300px;
        }
	}
    @media screen and (max-width: 1450px) {
        .nz_wrap {
            max-width: 1200px;
        }
	}
}
</style>